import ForgotPasswordForm from "./ForgotPasswordForm";
import { Link } from "react-router-dom";
import { PUBLIC_BASE } from "../../../../shared/lib/routesResolver";

const ForgotPasswordContainer = () => {
  return (
    <div className="mx-auto flex flex-col w-full justify-center space-y-6">
      <div className="flex flex-col space-y-2 text-center">
        <div className="flex justify-center">
          <img
            className="w-1/4"
            src="/login-form-logo.svg"
            alt="ADQUIVER MEDIA"
          />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Restablecimiento de contraseña
        </h1>
        <p className="text-sm text-muted-foreground">
          Por favor, introduzca su correo electrónico
        </p>
      </div>
      <ForgotPasswordForm />
      <div className="px-5 text-center text-sm underline text-adq-blue">
        <Link to={PUBLIC_BASE}>Volver al inicio</Link>
      </div>
    </div>
  );
};

export default ForgotPasswordContainer;